import React from 'react'
import {Link} from 'react-router-dom'

const Header = () => {
  return (
    <header>
        <div className="profile-page sidebar-collapse">
            <nav className="navbar navbar-expand-lg fixed-top navbar-transparent bg-primary" color-on-scroll="400">
            <div className="container">
                <div className="navbar-translate">
                <Link className='navbar-brand' rel='tooltip' to="/">SharifuMasudi</Link>
                <button className="navbar-toggler navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-bar bar1"></span><span className="navbar-toggler-bar bar2"></span><span className="navbar-toggler-bar bar3"></span></button>
                </div>
                <div className="collapse navbar-collapse justify-content-end" id="navigation">
                <ul className="navbar-nav">
                    <li className="nav-item">
                    <Link className="nav-link smooth-scroll" to="/about-me">About</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link smooth-scroll" to="/skills">Skills</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link smooth-scroll" to="/education">
                    Education
                    </Link></li>
                    <li className="nav-item">
                    <Link className="nav-link smooth-scroll" to="/working-experience">Experience</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link smooth-scroll" to="/contact-me">Contact</Link></li>
                </ul>
                </div>
            </div>
            </nav>
        </div>
    </header>
  )
}

export default Header
